import React from "react";
import "./ui.css";

export default function Progress({ value = 0 }) {
  const safeValue = Number.isFinite(Number(value)) ? Number(value) : 0;
  const clamped = Math.max(0, Math.min(100, safeValue));

  return (
    <div className="ui-progress" role="progressbar" aria-valuenow={clamped} aria-valuemin={0} aria-valuemax={100}>
      <div className="ui-progress__bar" style={{ width: `${clamped}%` }} />
      <div className="ui-progress__label">{clamped}%</div>
    </div>
  );
}
